import dash_api from '../../main/support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

const GET_USER_ONBOARDING_DATA_ENDPOINT = '/v1/user-onboarding-data';
const GetUserOnboardingData = new ReduxAsyncAction('GET_USER_ONBOARDING_DATA');
GetUserOnboardingData.registerRequest(function () {
  return dash_api.get(GET_USER_ONBOARDING_DATA_ENDPOINT).then(({ data }) => {
    return data;
  });
});
export const GET_USER_ONBOARDING_DATA = GetUserOnboardingData.constants;
export const getUserOnboardingData = GetUserOnboardingData.request;
